export default __webpack_public_path__ + "static/media/create-profile.95c34a00.png";